import { Component, ElementRef, input, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '@root/environments/environment';

@Component({
  selector: 'xemex-skeleton-block',
  host: {
    class: 'loading',
  },
  standalone: true,
  templateUrl: './skeleton-block.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './skeleton-block.component.scss',
})
export class SkeletonBlockComponent {
  width = input('100%');
  height = input('20px');
  color = input('#a2a2a2');
  borderRadius = input('16px');
  primaryHoverColors = environment.branding.styles.colors.primary.main;

  constructor(private host: ElementRef<HTMLElement>) {}

  ngOnInit() {
    const host = this.host.nativeElement;

    host.style.setProperty('--skeleton-rect-border-radius', this.borderRadius() ?? '16px');
    host.style.setProperty('--skeleton-rect-width', this.width() ?? '100%');
    host.style.setProperty('--skeleton-rect-height', this.height() ?? '20px');
    host.style.setProperty(
      '--skeleton-rect-color',
      this.color() === 'primary' ? `${this.primaryHoverColors}50` : '#a2a2a250',
    );
    host.style.setProperty(
      '--skeleton-rect-color-light',
      this.color() === 'primary' ? `${this.primaryHoverColors}20` : '#a2a2a220',
    );
  }
}
